"use strict";
import "../scss/style.scss";
// import './css_load';

import React, { useState, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import App from '../App.jsx';

const container = document.getElementById('root');
const root = createRoot(container);
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';

root.render(
  <HelmetProvider>
    <BrowserRouter basename="/">
      <App />
    </BrowserRouter>
  </HelmetProvider>
);
